export default "__VITE_PUBLIC_ASSET__101e6ca4__"